/**
 * @desc 组织架构同步
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.IAMCommonRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/iam/callback/dept`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
